// filepath: 
import React, { useState, useEffect } from "react";
import { Stack, TextField, Button, Typography, Tabs, Tab } from "@mui/material";
import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Paper } from "@mui/material";
import useCoinRules from "../../hooks/useCoinRules";
import { useSelector } from "react-redux";
import useUpdateCoinRule from "../../hooks/useUpdateCoinRule";
import { ToastContainer, toast } from "react-toastify";
import RewardCoinsTable from "./RewardCoinsTable";

const CoinMgtTable = () => {
  const [tabValue, setTabValue] = useState(0);
  const [editedData, setEditedData] = useState([]);
  const [editedDataTwo, setEditedDataTwo] = useState([]);
  const CoinTableData = useCoinRules();
  const TableData = useSelector((state) => state.coin.coinTable);
  const Data = useSelector((state) => state.app.curretDropdownData);
useEffect(() => {
  if (Data?.zone_name !== "Mumbai" && Data?.zone_name !== "Thane" && Data?.zone_name !== "Nagpur") {
    setTabValue(0);
  }
}, [Data?.zone_name]);
  const headerData = [
    "Value From",
    "Value To",
    "Cashback % From",
    "Cashback % To",
  ];

  useEffect(() => {
    CoinTableData();
  }, []);

  useEffect(() => {
    if (TableData) {
      setEditedData(TableData?.resultToday?.map((row) => ({ ...row })));
    }
  }, [TableData]);

  useEffect(() => {
    if (TableData) {
      setEditedDataTwo(TableData?.resultTomorrow?.map((row) => ({ ...row })));
    }
  }, [TableData]);

  const handleInputChange = (index, field, value) => {
    const updatedData = [...editedData];
    updatedData[index] = { ...updatedData[index], [field]: value };
    setEditedData(updatedData);
  };

  const handleInputChangeTwo = (index, field, value) => {
    const updatedData = [...editedDataTwo];
    updatedData[index] = { ...updatedData[index], [field]: value };
    setEditedDataTwo(updatedData);
  };

  const updateCoinRule = useUpdateCoinRule();

  const handleFormSubmit = () => {
    const isEmpty = editedData.some(
      (data) =>
        data.value_from === "" ||
        data.value_to === "" ||
        data.per_from === "" ||
        data.per_to === ""
    );

    if (isEmpty) {
      toast.error("All fields are required");
    } else {
      const data = updateCoinRule(editedData);
    }
  };

  const handleFormSubmitTwo = () => {
    const isEmpty = editedDataTwo.some(
      (data) =>
        data.value_from === "" ||
        data.value_to === "" ||
        data.per_from === "" ||
        data.per_to === ""
    );

    if (isEmpty) {
      toast.error("All fields are required");
    } else {
      const data = updateCoinRule(editedDataTwo);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (!Array.isArray(TableData?.resultToday)) {
    return <div>Loading...</div>;
  }

  return (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
        padding: "10px 10px",
        ".MuiTabs-indicator": {
          backgroundColor: "#DC1D13",
        },
      }}
    >
      {/* <Typography sx={{ textAlign: "left", fontSize: "32px" }}>
        Coin Management
      </Typography> */}

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        sx={{ marginBottom: 2 }}
      >
        <Tab sx={{ color: "#DC1D13 !important" }} label="Coin Management" />
        {Data?.zone_name === "Mumbai" || Data?.zone_name === "Thane" || Data?.zone_name === "Nagpur" ? <Tab sx={{ color: "#DC1D13 !important" }}  label="Reward Coins" /> : null}
      </Tabs>

      {tabValue === 0 && (
        <Stack
          gap={2}
          sx={{
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <form onSubmit={handleFormSubmit}>
            <Stack sx={{ alignItems: "center" }}>
              <Typography variant="h6" color="initial" sx={{ margin: "5px" }}>
                Today Delivery Rule
              </Typography>
              <TableContainer
                sx={{
                  minWidth: "100%",
                  borderRadius: "10px",
                  border: "1px solid gray",
                }}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead sx={{ backgroundColor: "#c4c4c4" }}>
                    <TableRow sx={{ backgroundColor: "#c4c4c4" }}>
                      {headerData.map((header, index) => (
                        <TableCell
                          sx={{
                            backgroundColor: "#c4c4c4",
                            textAlign: "center",
                          }}
                          key={index}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {TableData?.resultToday?.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ textAlign: "center" }}>
                          <TextField
                            size="small"
                            value={editedData[index]?.value_from}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "value_from",
                                e.target.value
                              )
                            }
                            error={editedData[index]?.value_from === ""}
                            helperText={
                              editedData[index]?.value_from === ""
                                ? "This Field is required"
                                : ""
                            }
                          />
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          <TextField
                            size="small"
                            value={editedData[index]?.value_to}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "value_to",
                                e.target.value
                              )
                            }
                            error={editedData[index]?.value_to === ""}
                            helperText={
                              editedData[index]?.value_to === ""
                                ? "This Field is required"
                                : ""
                            }
                          />
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          <TextField
                            size="small"
                            value={editedData[index]?.per_from}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "per_from",
                                e.target.value
                              )
                            }
                            error={editedData[index]?.per_from === ""}
                            helperText={
                              editedData[index]?.per_from === ""
                                ? "This Field is required"
                                : ""
                            }
                          />
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          <TextField
                            size="small"
                            value={editedData[index]?.per_to}
                            onChange={(e) =>
                              handleInputChange(index, "per_to", e.target.value)
                            }
                            error={editedData[index]?.per_to === ""}
                            helperText={
                              editedData[index]?.per_to === ""
                                ? "This Field is required"
                                : ""
                            }
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Button
                onClick={handleFormSubmit}
                variant="contained"
                color="primary"
                sx={{
                  backgroundColor: "#DC1D13",
                  marginTop: "14px",
                  textTransform: "none",
                  ":hover": { backgroundColor: "#e82217" },
                }}
              >
                Update
              </Button>
            </Stack>
          </form>

          <form onSubmit={handleFormSubmit}>
            <Stack sx={{ alignItems: "center" }}>
              <Typography variant="h6" color="initial" sx={{ margin: "5px" }}>
                Tomorrow Delivery Rule
              </Typography>
              <TableContainer
                sx={{
                  minWidth: "100%",
                  borderRadius: "10px",
                  border: "1px solid gray",
                }}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableHead sx={{ backgroundColor: "#c4c4c4" }}>
                    <TableRow sx={{ backgroundColor: "#c4c4c4" }}>
                      {headerData.map((header, index) => (
                        <TableCell
                          sx={{
                            backgroundColor: "#c4c4c4",
                            textAlign: "center",
                          }}
                          key={index}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {TableData?.resultTomorrow?.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ textAlign: "center" }}>
                          <TextField
                            size="small"
                            value={editedDataTwo[index]?.value_from}
                            onChange={(e) =>
                              handleInputChangeTwo(
                                index,
                                "value_from",
                                e.target.value
                              )
                            }
                            error={editedDataTwo[index]?.value_from === ""}
                            helperText={
                              editedDataTwo[index]?.value_from === ""
                                ? "This Field is required"
                                : ""
                            }
                          />
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          <TextField
                            size="small"
                            value={editedDataTwo[index]?.value_to}
                            onChange={(e) =>
                              handleInputChangeTwo(
                                index,
                                "value_to",
                                e.target.value
                              )
                            }
                            error={editedDataTwo[index]?.value_to === ""}
                            helperText={
                              editedDataTwo[index]?.value_to === ""
                                ? "This Field is required"
                                : ""
                            }
                          />
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          <TextField
                            size="small"
                            value={editedDataTwo[index]?.per_from}
                            onChange={(e) =>
                              handleInputChangeTwo(
                                index,
                                "per_from",
                                e.target.value
                              )
                            }
                            error={editedDataTwo[index]?.per_from === ""}
                            helperText={
                              editedDataTwo[index]?.per_from === ""
                                ? "This Field is required"
                                : ""
                            }
                          />
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          <TextField
                            size="small"
                            value={editedDataTwo[index]?.per_to}
                            onChange={(e) =>
                              handleInputChangeTwo(
                                index,
                                "per_to",
                                e.target.value
                              )
                            }
                            error={editedDataTwo[index]?.per_to === ""}
                            helperText={
                              editedDataTwo[index]?.per_to === ""
                                ? "This Field is required"
                                : ""
                            }
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Button
                onClick={handleFormSubmitTwo}
                variant="contained"
                color="primary"
                sx={{
                  backgroundColor: "#DC1D13",
                  marginTop: "14px",
                  textTransform: "none",
                  ":hover": { backgroundColor: "#e82217" },
                }}
              >
                Update
              </Button>
            </Stack>
          </form>
          <ToastContainer />
        </Stack>
      )}

      {tabValue === 1 && <RewardCoinsTable />}
    </Stack>
  );
};

export default CoinMgtTable;